import { UserApi, UserRoleApi } from '@core/api/model/user/user-api.model';
import { UserStateDirectory } from '@core/domain/model/user/individual-user-state.directory';
import {
  IndividualUserDetail,
  IndividualUserInstallation,
  IndividualUserRole,
  IndividualUserSociety,
} from '@core/domain/model/user/individual-user.model';
import { TagTransformer } from '../assistants/tag.transformer';
import { TagElement } from '../assistants/tags.directory';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';

export class UserDetailMapper {
  public static fromApi(api: UserApi): IndividualUserDetail {
    const state = UserStateDirectory[api.estado];
    return {
      ...api,
      idHashCRM: api.idHashCRM,
      name: api.nombre,
      lastName: api.apellidos,
      fullName: api.nombreCompleto,
      email: api.email,
      lastLogin: api.ultimoLoging ? new Date(api.ultimoLoging) : undefined,
      invoiceWarn: api.avisoFactura,
      phone: api.telefono,
      registrationDate: api.fechaAlta,
      state,
      stateTagType: TagTransformer.tagTypeFromCode(state, TagElement.USER_STATE),
    };
  }

  public static roleMapper(role: UserRoleApi): IndividualUserRole {
    const roleTypeMap: { [prop in UserRoleApi]: IndividualUserRole } = {
      ADMIN: 'ADMIN',
      USU: 'USER',
      SIN: 'NO_ACCESS',
    };
    return roleTypeMap[role];
  }

  public static installationMapper(api: MasterInstallationModel): IndividualUserInstallation {
    return {
      code: api.codigo,
      name: api.nombre,
      cups: api.cups,
      societyCode: api.codigoRazonSocial,
      societyName: api.nombreRazonSocial,
      role: api.role,
      accessRole: undefined,
      accessRoleTagType: undefined,
    };
  }

  public static societyMapper(
    api: MasterSocietyModel,
    installations: Array<IndividualUserInstallation>,
    accessRole?: UserRoleApi
  ): IndividualUserSociety {
    return {
      code: api.codigo,
      document: api.numDocumento,
      name: api.nombre,
      role: api.role,
      accessRole: accessRole ? UserDetailMapper.roleMapper(accessRole) : undefined,
      installations,
    };
  }
}
